import React from 'react';

import { TableRow } from '@mui/material';

import { rowStyles } from './SimpleTable.styles';
import SkeletonCell from './SkeletonCell';

const SimpleTableSkeleton = ({ rowsAmount }) =>
  Array.from({ length: rowsAmount }).map((_, index) => (
    <TableRow className="table-row" key={index} sx={rowStyles({})}>
      <SkeletonCell />
    </TableRow>
  ));

export default SimpleTableSkeleton;
